module.exports = __webpack_public_path__ + "static/img/manual-34.c73e992.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-34.png
// module id = NGHT
// module chunks = 4